import axios from '@fs/zion-axios'

const BASE_USERS_PATH = '/service/dmc/users'

export async function getGedcomFiles(cisId) {
  const response = await axios.get(`${BASE_USERS_PATH}/${cisId}/gedcom`)
  return response
}

export async function getGedcomFileMetadata(cisId, fileName) {
  const response = await axios.get(`${BASE_USERS_PATH}/${cisId}/gedcom/${fileName}`)
  return response
}

export async function downloadUserGedcomResultsErrors(cisId, fileName) {
  const path = `${BASE_USERS_PATH}/${cisId}/gedcom/${fileName}/results/errors`
  const response = await axios.get(path)
  return response
}

export async function reprocessGedcomFileUpload(cisId, fileName) {
  const response = await axios.post(`${BASE_USERS_PATH}/${cisId}/gedcom/${fileName}`)
  return response
}

export async function deleteGedcomFileUpload(cisId, fileName) {
  const response = await axios.delete(`${BASE_USERS_PATH}/${cisId}/gedcom/${fileName}`)
  return response
}

export async function getUserGedcomImportResults(cisId, fileName, treeId) {
  const response = await axios.get(`${BASE_USERS_PATH}/${cisId}/gedcom/import-results`, {
    params: { fileName, treeId },
  })
  return response
}
